// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__cv1_o","unreadBadge":"styles_unreadBadge__4NmMx","modalContent":"styles_modalContent___09mq","modal":"styles_modal__3LgM8"};